<template>
  <div>
    <h5>{{ $t('network.media.shareMediaToNetwork') }}</h5>
    <p>{{ $t( 'network.media.shareCollectionToNetworkDescription' ) }}</p>

    <b-form-input id="collection_name" v-model="collectionName" data-test="collection_name" :placeholder="$t('network.collection.name')" class="mt-2 mb-4" />
    <v-select
      id="selected_networks"
      v-model="selectedNetworks"
      data-test="selected_networks"
      :options="sortedArray(networks)"
      label="name"
      :placeholder="this.$t('network.networkForm.selectNetwork')"
      multiple
    ></v-select>

    <div class="mt-4">
      <button id="add_collection" data-test="add_collection" :disabled="!(selectedNetworks.length > 0 && collectionName)" class="btn btn-primary" @click.prevent="addNewCollection">
        {{ $t('ShareCollectionToNetwork.add-collection') }}
      </button>
    </div>
  </div>
</template>
<script>
import { OrganizedTreeService } from '@/services/OrganizedTreeService.js';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import sortBy from 'lodash/sortBy';

export default {
  components: {
    vSelect,
  },
  props: {
    networks: {
      type: Array,
      default: null,
    },
    treeData: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      selectedNetworks: [],
      collectionName: '',
    };
  },
  methods: {
    addNewCollection() {
      this.addMediaCollection(this.getCollectionFromSelectedNodes(), this.getMediaFromSelectedNodes());
    },
    getCollectionFromSelectedNodes() {
      let result = [];
      new OrganizedTreeService().buildCollectionFromSelectedNodes(this.treeData, result);
      return result;
    },
    getMediaFromSelectedNodes() {
      let result = [];
      new OrganizedTreeService().getAllCheckedMediaInTree(this.treeData, result);
      result = result.map(r => r.slug);
      return result;
    },
    addMediaCollection(tree, media) {
      let action = () => {
        let url = 'networks/collections/share';
        let data = { name: this.collectionName, tree: JSON.stringify(tree), media, networks: this.selectedNetworks.map(n => n.id) };
        this.$http.post(url, data).then(resp => {
          this.$bus.emit('collection-share-complete');
          window.open('/networks/collections/' + resp.data.slug + '/edit', '_blank');
        });
      };
      let msg = this.$t('network.collection.shareCollectionConfirm');
      this.showConfirmPrompt(action, msg);
    },
    sortedArray(array) {
      return sortBy(array, 'name');
    },
  },
};
</script>
